import { ApiClientReturnType, KeyLabelType, Nullable, TableDataType } from '~/types';
import api from '../../http-common';
import { FixedPricePrefixType } from '../dashboard';
import { FarmerProfileType, TradingMonthType } from './index';

const getShowFarmerData = (id: string): ApiClientReturnType<FarmerShowType> =>
  api.post(`/farmers/${id}/show`)

const getShowFarmerUsersData = (data: FarmerUserFilType): ApiClientReturnType<FarmerUsersType> =>
  api.post('/farmers/users/index', data)

const countFarmerUsers = (data: FarmerUserFilType) =>
  api.post('/farmers/users/count', data)

const getShowFarmerUsersOptions = (): ApiClientReturnType<{ types: KeyLabelType[] }> =>
  api.post('/farmers/users/get-index-data')

const getProfileFarmerData = (id: string): ApiClientReturnType<FarmerProfileType> =>
  api.post(`/farmers/${id}/get-profile-data`)

const getTradingActivitiesFarmer = (id: string, prefix: FixedPricePrefixType, data?: FarmerTradingFilType): ApiClientReturnType<FarmerTradingActType> =>
  api.post(`/farmers/${id}/${prefix}/trading-activities/index`, data)

const blockTradingActivitiesFarmerAmount = (idFarmer: string, idActivity: string, prefix: FixedPricePrefixType, data?: FarmerTradingFilType): ApiClientReturnType<void> =>
  api.post(`/farmers/${idFarmer}/${prefix}/trading-activities/${idActivity}/cancel`, data)

const deleteFarmerOfferAmount = (idFarmer: string, prefix: FixedPricePrefixType, idOffer: string): ApiClientReturnType<void> =>
  api.post(`/farmers/${idFarmer}/${prefix}/trading-activities/${idOffer}/delete`)

const getTradingMonths = (id: string, prefix: FixedPricePrefixType, data?: FarmerTradingFilType): ApiClientReturnType<TableDataType<TradingMonthType>> =>
  api.post(`/farmers/${id}/${prefix}/trading-months/index`, data)

const getEmailsOptions = (id: string): ApiClientReturnType<{ statuses: KeyLabelType[], types: KeyLabelType[] }> =>
  api.post(`/farmers/${id}/logs/emails/get-index-data`)

const getEmails = (id: string, data?: FarmerEmailFilType): ApiClientReturnType<FarmerEmailsType> =>
  api.post(`/farmers/${id}/logs/emails/index`, data)

const getFarmersActivityLogs = (id: string, data?: FarmerActLogFilType): ApiClientReturnType<FarmerActLogType> =>
  api.post(`/farmers/${id}/logs/activities/index`, data)

const getFarmersActivityLogsExport = (id: string, data?: FarmerActLogFilType): ApiClientReturnType<any> =>
  api.post(`/farmers/${id}/logs/activities/export`, data)

const getSmsLogs = (id: string, data?: FarmerSmsFilType): ApiClientReturnType<FarmerSMSLogType> =>
  api.post(`/farmers/${id}/logs/messages/index`, data)

const getSmsLogsOptions = (id: string, data?: FarmerSmsFilType): ApiClientReturnType<FarmerSMSOptType> =>
  api.post(`/farmers/${id}/logs/messages/get-index-data`, data)

// farmer details

const getFarmerDetails = (id: string): ApiClientReturnType<FarmerDetailType> =>
  api.post(`/farmers/${id}/profile/get-data`)

const updateFarmerDetails = (id: string, data: Farmer): ApiClientReturnType<void> =>
  api.post(`/farmers/${id}/profile/update`, data)

// farmer contacts

const getContacts = (id: string, data: { page: number, rows: number }): ApiClientReturnType<TableDataType<ContactType>> =>
  api.post(`/farmers/${id}/contacts/index`, data)

const storeContact = (id: string, data: { page: number, rows: number }): ApiClientReturnType<void> =>
  api.post(`/farmers/${id}/contacts/store`, data)

const getContact = (idFarmer: string, idContact: string): ApiClientReturnType<ContactType> =>
  api.post(`/farmers/${idFarmer}/contacts/${idContact}/edit`)

const updateContact = (idFarmer: string, idContact: string, data: { page: number, rows: number }): ApiClientReturnType<void> =>
  api.post(`/farmers/${idFarmer}/contacts/${idContact}/update`, data)

const deleteContact = (idFarmer: string, idContact: string): ApiClientReturnType<void> =>
  api.post(`/farmers/${idFarmer}/contacts/${idContact}/delete`)

// farmer communication

const getNotesOptions = (id: string): ApiClientReturnType<NotesOptions> =>
  api.post(`/farmers/${id}/notes/get-options-data`)

const getNotes = (id: string, data: { page: number, rows: number }) =>
  api.post(`/farmers/${id}/notes/index`, data)

const storeNote = (id: string, data: { page: number, rows: number }): ApiClientReturnType<void> =>
  api.post(`/farmers/${id}/notes/store`, data)

const getNote = (idFarmer: string, idContact: string) =>
  api.post(`/farmers/${idFarmer}/notes/${idContact}/edit`)

const updateNote = (idFarmer: string, idContact: string, data: { page: number, rows: number }): ApiClientReturnType<void> =>
  api.post(`/farmers/${idFarmer}/notes/${idContact}/update`, data)

// material info

const getFormHusbandryOptions = (id: string): ApiClientReturnType<FarmerHusbandryOptType> =>
  api.post(`/farmers/${id}/commodities/husbandry-forms/get-options-data`)

const getFormHusbandry = (id: string): ApiClientReturnType<FarmerHusbandryType> =>
  api.post(`/farmers/${id}/commodities/husbandry-forms/get-data`)

const updateFormHusbandry = (id: string, data: { husbandryForms: HusbandryForm[] }): ApiClientReturnType<void> =>
  api.post(`/farmers/${id}/commodities/husbandry-forms/update`, data)

const getMilkTypesOptions = (id: string): ApiClientReturnType<MilkTypeOptions> =>
  api.post(`/farmers/${id}/commodities/milk-types/get-options-data`)

const getMilkTypes = (id: string): ApiClientReturnType<{ milkTypeId: number }> =>
  api.post(`/farmers/${id}/commodities/milk-types/get-data`)

const updateMilkTypes = (id: string, data: { milkTypeId: number }): ApiClientReturnType<void> =>
  api.post(`/farmers/${id}/commodities/milk-types/update`, data)

// financial info

const getFinancialFarmerData = (id: string): ApiClientReturnType<FarmerFinType> =>
  api.post(`/farmers/${id}/finances/bank-data/get-data`)

const updateFinancialFarmerData = (id: string, data: FarmerUpdateFinType): ApiClientReturnType<void> =>
  api.post(`/farmers/${id}/finances/bank-data/update`, data)

const checkIban = (id: string, data: { iban: string }): ApiClientReturnType<IbanCheckType> =>
  api.post(`/farmers/${id}/finances/bank-data/check-data`, data)

const getTaxData = (id: string): ApiClientReturnType<FarmerTaxDataType> =>
  api.post(`/farmers/${id}/finances/tax-data/get-data`)

const updateTaxData = (id: string, data: FarmerUpdateTaxDataType): ApiClientReturnType<void> =>
  api.post(`/farmers/${id}/finances/tax-data/update`, data)

const getTaxation = (id: string) =>
  api.post(`/farmers/${id}/finances/taxation/get-data`)

const getTaxationOptions = (id: string) =>
  api.post(`/farmers/${id}/finances/taxation/get-options-data`)

const updateTaxation = (id: string, data: FarmerTaxationData): ApiClientReturnType<void> =>
  api.post(`/farmers/${id}/finances/taxation/update`, data)

// mga details

const getMgaDetails = (id: string, data: any) =>
  api.post(`/farmers/${id}/milk-payment/invoices/index`, data)

const getMgaData = (id: string) =>
  api.post(`/farmers/${id}/milk-payment/details/get-data`)

const updateMgaDetails = (id: string, data: any) =>
  api.post(`/farmers/${id}/milk-payment/details/update`, data)

const getMgaDetailsPdf = (id: string, data: any) =>
  api.post(`/farmers/${id}/milk-payment/invoices/{invoiceId}/preview/pdf`, data)

// milk samples

const getMilkSamplesData = (id: string, data: any) =>
  api.post(`/farmers/${id}/milk-payment/milk-samples/individual-values/get-index-data`, data)

const getMilkSamples = (id: string, data: any, prefix: string) =>
  api.post(`/farmers/${id}/milk-payment/milk-samples/${prefix}/index`, data)

// milk deliveries

const getMilkDeliveries = (id: string, data: any) =>
  api.post(`/farmers/${id}/milk-payment/milk-deliveries/index`, data)

const getMilkDeliveriesData = (id: string) =>
  api.post(`/farmers/${id}/milk-payment/milk-deliveries/get-index-data`)

// co2 footprint

const getCO2Fooprints = (id: string, data: any) =>
  api.post(`/farmers/${id}/co2-footprint/results/index`, data)

const getCO2FooprintData = (id: string, co2FootprintId: string) =>
  api.post(`/farmers/${id}/co2-footprint/results/${co2FootprintId}/get-data`)

const getClimaFooprintData = (id: string, co2FootprintId: string) =>
  api.post(`/farmers/${id}/climate-check-footprint/results/${co2FootprintId}/get-data`)

// clima footprint

const getClimaFootprints = (id: string, data: any) =>
  api.post(`/farmers/${id}/climate-check-footprint/results/index`, data)

// hedging info

const getHedgingInfo = (id: string) =>
  api.post(`/farmers/${id}/trading-slot/get-data`)

const updateHedginInfo = (id: string, data: any) =>
  api.post(`/farmers/${id}/trading-slot/update`, data)

// Monthly contracts amounts

const getMontlyContractAmounts = (id: string, data: any) =>
  api.post(`/farmers/${id}/monthly-contract-amounts/index`, data)

// Managers logs

const getManagerSmsLogs = (id: string, data?: FarmerSmsFilType): ApiClientReturnType<FarmerSMSLogType> =>
  api.post(`/managers/${id}/logs/messages/index`, data)

const getManagerSmsLogsOptions = (id: string, data?: FarmerSmsFilType): ApiClientReturnType<FarmerSMSOptType> =>
  api.post(`/managers/${id}/logs/messages/get-index-data`, data)

const getManagerEmailsOptions = (id: string): ApiClientReturnType<{ statuses: KeyLabelType[], types: KeyLabelType[] }> =>
  api.post(`/managers/${id}/logs/emails/get-index-data`)

const getManagerEmails = (id: string, data?: FarmerEmailFilType): ApiClientReturnType<FarmerEmailsType> =>
  api.post(`/managers/${id}/logs/emails/index`, data)

const getManagerActivityLogs = (id: string, data?: FarmerActLogFilType): ApiClientReturnType<FarmerActLogType> =>
  api.post(`/managers/${id}/logs/activities/index`, data)

const getManagerActivityLogsExport = (id: string, data?: FarmerActLogFilType): ApiClientReturnType<any> =>
  api.post(`/managers/${id}/logs/activities/export`, data)

export const ShowFarmerService = {
  getTaxData,
  updateTaxData,
  getFormHusbandry,
  getFormHusbandryOptions,
  updateFormHusbandry,
  getSmsLogs,
  getSmsLogsOptions,
  getEmails,
  getEmailsOptions,
  deleteFarmerOfferAmount,
  getFarmersActivityLogs,
  getFarmersActivityLogsExport,
  blockTradingActivitiesFarmerAmount,
  getShowFarmerUsersData,
  getShowFarmerUsersOptions,
  getShowFarmerData,
  getProfileFarmerData,
  getFinancialFarmerData,
  getTradingActivitiesFarmer,
  updateFinancialFarmerData,
  getTradingMonths,
  getFarmerDetails,
  updateFarmerDetails,
  getContact,
  updateContact,
  storeContact,
  getContacts,
  deleteContact,
  getNote,
  storeNote,
  updateNote,
  getNotes,
  getNotesOptions,
  getMilkTypes,
  getMilkTypesOptions,
  updateMilkTypes,
  checkIban,
  getMgaDetails,
  getMgaData,
  getMgaDetailsPdf,
  updateMgaDetails,
  getMilkSamples,
  getMilkSamplesData,
  getMilkDeliveries,
  getMilkDeliveriesData,
  getCO2Fooprints,
  getCO2FooprintData,
  getHedgingInfo,
  updateHedginInfo,
  getTaxation,
  getTaxationOptions,
  updateTaxation,
  getMontlyContractAmounts,
  getClimaFooprintData,
  getManagerSmsLogs,
  getManagerSmsLogsOptions,
  getManagerEmails,
  getManagerEmailsOptions,
  getManagerActivityLogs,
  getManagerActivityLogsExport,
  getClimaFootprints,
  countFarmerUsers
}

export interface FarmerShowType {
  tradingAmountStatuses: KeyLabelType[];
  settings: Settings;
  farmer: FarmerDataType;
}

export interface FarmerDataType {
  id: string;
  supplierNo: string;
  companyName: string;
  evsNumber?: string;
  status: number;
  milkTypeId: number;
  createdAt: string;
  isMain: number;
  contractTypeId: number;
  milkType: null;
  contractType: ContractType;
}

export interface ContractType {
  id: number;
  slug: string;
  status: number;
  label: string;
}

export interface Settings {
  supplierNoUnique: number;
}

export interface FarmerShowDataType {
  id: string;
  supplierNo: string;
  companyName: string;
  status: number;
  milkTypeId: number;
  createdAt: Date;
  default: number;
  isBio: number;
  additionalInfo: null;
  abbreviation: string;
  name: string;
  label: string;
  languageId: number;
}

export interface TradingAmountStatus {
  key: string;
  label: string;
}

export type FarmerUsersType = TableDataType<FarmerUserType>

export interface FarmerUserType {
  id: string;
  supplierNo: string;
  companyName: string;
  name: string;
  email: string;
  status: number;
  lastLogin: null | string;
  verified: number;
  farmerId: string;
  mobilePrefix: number;
  mobileNumber: string;
  mobilePrefixCountryId: number;
  mobilePrefixCountryIso: string;
  mobilePrefixCountryPhoneCode: string;
  mobilePrefixCountryLabel: string;
}

export type FarmerUserFilType = {
  page: number,
  type: string,
  search: string,
  status: Nullable<string>,
  rows: number
  farmerId: string
}

export interface FarmerFinType {
  saleTaxes: SaleTax[];
}

export interface SaleTax {
  id: string;
  name: string;
  percent: string;
  status: number;
  saleTaxLabel: string;
}

export interface FarmerTaxDataType {
  taxNumber: string;
}

export interface FarmerTaxationData {
  saleTaxes: SaleTax[]
}

export interface FarmerUpdateTaxDataType {
  taxNumber: number | string
}

export type FarmerTradingFilType = {
  page: number,
  search: string,
  status: Nullable<string>,
  rows: number
}

export type FarmerTradingActType = TableDataType<TradingRowType>

export interface TradingRowType {
  id: string;
  uniqueId: string;
  createdAt: string;
  status: string;
  amount: number;
  confirmedAmount: number | null;
  tradingSlotId: string;
  tradingMonthId: string;
  price: string;
  date: Date;
  tradingSlotUniqueId: string;
  confirmationDate: null | string;
  offerDeleteAvailable: number;
  statusLabel: string;
}

export interface FarmerUpdateFinType {
  settings: Setting[];
}

export interface Setting {
  bankName: string;
  iban: string;
  bic: string;
  status: number;
  id: string | number;
}

export type FarmerEmailsType = TableDataType<{
  id: number;
  name: string;
  email: string;
  status: string;
  type: string;
  subject: string;
  sentDate: string;
  deliveredDate: string;
  openedDate: null;
  statusLabel: string;
  typeLabel: string;
}>

export type FarmerEmailFilType = {
  status: string,
  type: string,
  sentDateFrom: string,
  sentDateTo: string,
  search: string,
  column: string,
  sort: string,
  page: number,
  rows: number
}

export type FarmerActLogType = TableDataType<{
  createdAt: string;
  name: string;
  userId: string;
  supplierNo: string;
  farmerId: string;
  roleSlug: string;
  description: string;
  browserName: string;
  browserVersion: string;
  device: null;
  platformName: string;
  platformVersion: null;
  ipAddress: string;
  contentTitle: null;
  contentId: null;
  label: string;
  roleLabel: string;
}>

export type FarmerActLogFilType = {
  page: number,
  rows: number,
  search: string,
  type: string,
  action: string,
  dateFrom: string,
  dateTo: string
}

export interface FarmerHusbandryType {
  husbandryForms: HusbandryForm[];
}

export interface HusbandryForm {
  id: number;
  farmerId: string;
  husbandryFormId: number;
  dateFrom: string;
  dateTo: Nullable<string>;
}

export interface FarmerHusbandryOptType {
  husbandryForms: HusbandryFormOptionType[];
}

export interface HusbandryFormOptionType {
  id: number;
  color: string;
  price: null | string;
  bonusPrice: null | string;
  name?: string;
  abbreviation?: string;
  description?: string;
  label?: string;
  husbandryFormId?: number;
  languageId?: number;
  languages?: any[];
}

export type FarmerSMSLogType = TableDataType<{
  sender: string;
  content: string;
  mobileNumber: string;
  status: string;
  date: string;
  operator: string;
}
>

export type FarmerSmsFilType = {
  rows: number,
  page: number,
  from: string,
  to: string,
  status: string,
  userId: string
}

export interface FarmerSMSOptType {
  statuses: KeyLabelType[];
  users: User[];
}

export interface User {
  id: string;
  name: string;
  mobileNumber: null | string;
}

export interface FarmerDetailType {
  tradingVolumeTypes: TradingVolumeType[];
  farmer: Farmer;
}

export interface Farmer {
  id: string;
  supplierNo: string;
  internalId: null;
  lastDeliveryDate: null;
  terminationDate: null;
  phonePrefix: null;
  phoneNumber: null;
  telefaxPrefix: null;
  telefaxNumber: null;
  farmerGroupId: string;
  parentId: null;
  amount: number;
  companyName: string;
  amountPercent: string;
  minimumContingent: number;
  name: string;
  tradingAmount: string;
  monthlyTradingAmount: string;
  addressableId: string;
  streetName: string;
  streetNumber: string;
  evsNumber?: string;
  zip: string;
  city: string;
  countryId: number;
  localDistrict: null;
  stateId: number;
  districtId: number;
  agricultureDistrictId: null;
  latitude: string;
  longitude: string;
  countryIso: string;
  countryLabel: string;
  stateName: string;
  abbreviation: string;
  standardFat: string;
  standardProtein: string;
  fatPrice: string;
  proteinPrice: string;
  label: string;
  districtName: string;
  agricultureDistrict: null;
  phonePrefixCountry: null;
  telefaxPrefixCountry: null;
  mainFarmer: null;
  subFarmers: SubFarmer[];
}

export interface SubFarmer {
  id: string;
  companyName: string;
  supplierNo: string;
  parentId: string;
}

export interface TradingVolumeType {
  id: string;
  percent: string;
  tradingAmount: number;
  code: string;
  icon: string;
  name: string;
  label: string;
  tradingVolumeTypeId: string;
  languageId: number;
}

export interface ContactType {
  firstName: string;
  lastName: string;
  position: Nullable<string>;
  mobileNumber: Nullable<string>;
  phoneNumber: Nullable<string>;
  email: Nullable<string>;
}

export interface NotesOptions {
  users: NoteUser[];
  contacts: Contact[];
}

export interface Contact {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  position: null;
}

export interface NoteUser {
  id: string;
  name: string;
  email: string;
}

export interface MilkTypeOptions {
  milkTypes: MilkType[];
}

export interface MilkType {
  id: number;
  default: number;
  status: number;
  isBio: number;
  additionalInfo: null;
  abbreviation: string;
  name: string;
  label: string;
  milkTypeId: number;
  languageId: number;
}
export interface IbanCheckType {
  bankName: string;
  iban: string;
  ibanValid: number;
  bic: string;
}

